import styled from "styled-components";

export const PinkWrapper = styled.div`
    min-height: max-content;
    height: 100vh;
    display: flex;
    padding: 65px 64px;
    flex-direction: column;

    @media(max-width: 875px) {
        gap: 47px;
        align-items: center;
    }

    @media(max-width: 572px) {
        padding: 65px 16px;
    }
`

export const Wrapper = styled.div`
    display: grid;
    justify-content: center;
    align-items: center;
    max-width: 450px;
    height: max-content;
    margin: auto;

    @media(max-width: 572px) {
        width: 100%;
    }
`;

export const PageTitle = styled.div`
    font-style: normal;
    font-weight: 700;
    font-size: 24px;
    line-height: 32px;
    text-align: center;
    color: #1A1A1A;
    letter-spacing: -0.02em;
    font-family: "Athletics";
    display: flex;
    align-items: center;
    gap: 8px;
`

export const Subliner = styled.div`
    color: #757575;
    font-family: "Inter";
    font-weight: 400;
    font-size: 16px;
    line-height: 20px;
    text-align: center;

`

export const SecondSectionTitle = styled.div`
    margin: 12px 0;
    text-align: left;
`

export const FormStyle = styled.form`
    margin-top: 16px;
`;

export const FormFooter = styled.div`
    margin-top: 24px;
    align-items: center;
`;

export const FormInputDiv = styled.div`
    margin-bottom: ${(props: { $hasError?: boolean }) =>
            props.$hasError ? "16px" : "20px"};
    width: 100%;
    position: relative;
    text-align: left;

    & > span {
        font-family: "Inter";
        font-weight: 400;
        font-size: 10px;
        line-height: 15.6px;
        margin-top: 4px;
        color: var(--primary-pink);
        text-align: left;
  }
    
  @media(max-width: 768px) {
        margin-bottom: ${(props: { $hasError?: boolean }) =>
            props.$hasError ? "12px" : "16px"};
  }
`;

export const FormsFlex = styled.div`
    display: flex;
    gap: 24px;

  @media(max-width: 768px) {
        flex-direction: column;
        gap: 0;
  }
`;